const Style = {

  breadcrumbs: 'overflow-auto mb-2',
  link: `float-left m0 cursor-pointer no-underline 
    hover:text-blue-400 after:content-['_/'] after:mx-2 after:text-slate-300
    last:after:content-['']`,

}

export default Style;